import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import { useRootStore } from 'store/rootStore';
import FormsSpinner from 'components/common/loaders/FormSpinner';
import { useQueryParams } from '@insurancemenu/imenu-components-lib';
import RFQInfoPanel from '../RFQInfoPanel';
import RFQProposalPlans from '../RFQProposalPlans';

const RFQProposalPageContent: React.FC = observer(() => {
  const query = useQueryParams();
  const { periodId } = useParams<{ periodId: string }>();

  const {
    proposalItemsStore: { loadingGetter, loading, collectProposalData },
  } = useRootStore();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    void collectProposalData(query.get('groupId')!, query.get('cartId')!, periodId);
  }, []);

  return (
    <>
      {!loadingGetter && (
        <>
          <RFQInfoPanel />
          <RFQProposalPlans />
        </>
      )}
      <FormsSpinner display={loading} />
    </>
  );
});

export default RFQProposalPageContent;
